import { PageHeader } from "@/components/page";
import { AppUrlPath } from "@/lib/AppUrlPath";
import { useTenantStore } from "@/stores/tenantStore";
import { Button } from "@repo/ui/components/Base/Button";
import { useNavigate, useParams } from "react-router-dom";

export const IntegrationsPage = () => {
  const navigate = useNavigate();
  const { tenantId } = useParams();
  const tenant = useTenantStore((s) => s.tenant);

  if (!tenantId || !tenant) return null;

  const integrations: React.ReactNode[] = [];

  if (tenant.featureFlags?.laserfiche) {
    integrations.push(
      <div
        key="laserfiche"
        className="w-full px-6 py-4 rounded-lg border border-slate-400 flex flex-col gap-5"
      >
        <p className="font-bold text-lg">Integrate CiviDocs with Laserfiche.</p>

        <p>
          Each time a meeting is published, the meeting agenda can be copied to
          Laserfiche. Additionally, all documents attached to items on this
          agenda can be copied to Laserfiche. Lastly, when meeting minutes for a
          meeting are marked official, these minutes can be copied to Laserfiche
          as well.
        </p>
        <p>
          All documents copied to Laserfiche are placed in a root folder, then
          categorized by team folders, and then by meeting folders. All files
          associated with a meeting are grouped in the meeting folder &ndash;
          the meeting agenda, attached documents, and the minutes for that
          meeting.
        </p>
        <p>
          When any documents are copied to Laserfiche, they can be assigned
          Laserfiche tags, templates, and fields as needed.
        </p>

        <Button
          className="self-start"
          onClick={() =>
            navigate(
              new AppUrlPath(tenantId).getIntegrationPath(
                "laserfiche",
                "default"
              )
            )
          }
        >
          Connect to Laserfiche &raquo;
        </Button>
      </div>
    );
  }

  return (
    <div className="flex flex-col flex-grow gap-y-5 items-start">
      <PageHeader title="Integrations" />

      {integrations}

      {!integrations.length && (
        <p className="mx-1 opacity-50">No integrations available.</p>
      )}
    </div>
  );
};
